import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { PromotionService } from 'src/app/services/promotion.service';
import swal from 'sweetalert2';


@Component({
    selector: 'app-shop-promotion',
    templateUrl: './shop-promotions-add.component.html',
    styleUrls: ['./shop-promotions-add.component.scss']
})
export class ShopPromotionsAddComponent implements OnInit {
    form: any;
    filteredList1 = []
    dateWithTime: string;
    FileExtention: string;
    fileName: string;
    isFileSelected: boolean = true;
    BannerImage: File
    userImageBase64: string;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    promotionDetail: any;
    productlist = [];
    subCategorylist: any[] = [];
    promotionId: number = 0;
    promotion: any;
    showSelectedImage: boolean = false;
    selectedimageUpload: string | null = null;
    showSelectedPromoImage: boolean = false;
    isForSubCategory: boolean = false;
    groupedProducts: any[] = [];
    searchTerm: string = '';
    baseImageUrl = "https://dev.home-connect.co.za/Promoimage/promotions/"


    constructor(private fb: FormBuilder, private activateroute: ActivatedRoute, private lookupDataService: LookupDataServiceService,
        private PromotionService: PromotionService, private navigationService: NavigationService, private toast: NotificationService
    ) {
        this.activateroute.params.subscribe((params: any) => {
            this.promotionId = parseInt(params.id);
        });
    }

    ngOnInit() {
        this.initializeValidators()
        this.executeServiceQueue()
    }
    initializeValidators() {
        this.form = this.fb.group({
            promotionName: [null, [Validators.required]],
            PromoPrice: [null ],
            isForSubCategory: [false],
            startOnTs: [null, [Validators.required]],
            expiredOnTs: [null],
            imageName: [null, ],
            Image: [null,],
            productDetailId: [null],
            productSubCategoryId: [null],
        });
    }
    selectFile(): void {
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.style.display = 'none';
        document.body.appendChild(inputElement);
        inputElement.click();
        inputElement.addEventListener('change', (event) => {
            const files: FileList = (event.target as HTMLInputElement).files;

            if (!files || files.length == 0) {
                swal.fire('Warning', 'Please upload file', 'warning');
                return;
            }
            this.dateWithTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            this.fileName = files.item(0).name;
            var file = files.item(0);
            var fileExtension = this.fileName.slice(this.fileName.lastIndexOf('.') + 1);
            var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
            var result = '|png|jpeg|jpg|pdf|doc|docx'.indexOf(type) !== -1 || '|png|jpeg|jpg|pdf|doc|docx'.indexOf(fileExtension) !== -1;

            if (!result) {
                swal.fire('Warning', `Please upload a Correct File Format (PNG, JPEG, JPG)`, 'warning');
                this.fileName = ' ';
                this.dateWithTime = ' ';
                this.isFileSelected = true;
                return;
            }
            if (file.size > 4194304) {
                swal.fire('Warning', `The file being uploaded can't be more than 4MB`, 'warning');
                this.fileName = ' ';
                this.dateWithTime = ' ';
                this.isFileSelected = true;
                return;
            }
            this.FileExtention = fileExtension;
            this.isFileSelected = false;
            this.BannerImage = file;
            const reader1 = new FileReader();
            reader1.onloadend = () => {
                this.userImageBase64 = reader1.result as string;
                this.userImageBase64 = `data:image/${fileExtension === 'jpg' || type === 'jpeg' ? 'jpeg' : 'png'};base64,${this.userImageBase64.split(',')[1]}`;

                // Set the src attribute of the img element
                let bannerImageElement = document.getElementById('bannerImage') as HTMLImageElement;
                bannerImageElement.src = this.userImageBase64;
            };

            reader1.readAsDataURL(file);
            reader1.onerror = function () {
                swal.fire('Error', 'Failed to read file', 'error');
            };
            document.body.removeChild(inputElement);
            this.form.controls['imageName'].setValue(this.fileName);
        });
    }


    reset() {
        const txt = 'Are you sure want to delete?';
        const Yes = 'Yes';
        const No = 'No';
        swal.fire({
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.value) {
                this.fileName = "";
                this.dateWithTime = " ";
                this.isFileSelected = true;
                this.form.controls['imageName'].setValue(this.fileName);
                const bannerImageElement = document.getElementById('bannerImage') as HTMLImageElement;
                bannerImageElement.src = null;
            }
        });
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.form.controls["startOnTs"].value;
    }

    executeServiceQueue() {
        debugger
        this.lookupDataService.getProductsByCategory().subscribe((serviceResponse: any[]) => {
            debugger

            this.productlist = serviceResponse;
            this.productlist.forEach(item => {
                item.productCategoryName = item.productSubCategory.subCategoryName;
                this.groupedProducts = this.productlist.reduce((acc, product) => {
                    let category = product.productCategoryName;
                    let group = acc.find(g => g.categoryName === category);

                    if (!group) {
                        group = { categoryName: category, products: [] };
                        acc.push(group);
                    }

                    group.products.push(product);
                    return acc;
                }, []);
            });
            console.log("grouped products",this.groupedProducts);

            this.groupedProducts.forEach(grpres => {
                this.subCategorylist.push(
                    { "Id": grpres.products[0].productSubCategoryId, "SubCategoryName": grpres.categoryName }
                )
                this.filteredList1 = this.subCategorylist.slice()
            })

            if (this.promotionId != 0) {
                this.PromotionService.getPromotionById(this.promotionId).subscribe((results: any) => {
                    debugger
                    this.fileName = results.imageName


                    const formatCurrency = (n: number, currency: string): string => {
                        return currency + " " + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    };
                    this.promotionDetail = results;
                    this.form.patchValue({
                        promotionName: results.promotionName,
                        productDetailId: results.productDetailId,
                        selectedProductDetailId: results.productDetailId,
                        productSubCategoryId: results.productSubCategoryId,
                        imageName: results.imageName,
                        isForSubCategory: results.isForSubCategory,
                        PromoPrice: !results.isForSubCategory ? formatCurrency(results.promoPrice, "") : '',
                        startOnTs: results.startOnTs,
                        expiredOnTs: results.expiredOnTs
                    })
                    this.showSelectedImage = true;
                    let slicedText = this.sliceAfterBackslash(results.image);
                    let bannerImageElement = document.getElementById('bannerImage') as HTMLImageElement;
                    bannerImageElement.src = this.baseImageUrl + slicedText
                });
            }

        });
    }
    sliceAfterBackslash(text: string): string {
        const index = text.lastIndexOf('\\');
        return text.slice(index + 1);
    }
    filteredGroupedProducts() {
        if (!this.searchTerm) {
            return this.groupedProducts;
        }

        return this.groupedProducts.map(group => ({
            categoryName: group.categoryName,
            products: group.products.filter(product =>
                product.aliasName.toLowerCase().includes(this.searchTerm.toLowerCase())
            )
        })).filter(group => group.products.length > 0); // Ensure no empty groups are shown
    }

    save() {
        debugger
        if (this.form.valid) {
            debugger
            let formValues = this.form.getRawValue();

            formValues.Image = this.promotionId == 0 ? this.userImageBase64 : this.promotionDetail.image;
            // formValues.imageName = this.fileName

            let payload: any
            payload = { ...this.promotionDetail, ...formValues }
            this.PromotionService.savePromotion(payload).subscribe((results) => {
                if (results) {
                    this.toast.showSuccess("save successfully!")
                    this.navigationService.goToShopPromotion();
                }
            });

        }
        else {
            this.toast.showError("Please fill the require fields!")
            this.form.markAllAsTouched()
            return
        }
    }
    goToManagePromotionForm() {
        this.navigationService.goToShopPromotion();
    }
}
